import { useSelector } from 'react-redux'

import { getCurrentUserSelector, selectedPartnershipRightsHolderSelfAccountSelector } from '../../modules/selectors/app'
import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../constants/selectLists/platformList'
import { selectedPartnershipSelector } from '../../modules/selectors/partnerships'

// platform connection consists with 2 flows:
// 1) based on selectedPartnership and taking auth connection from auth_user
// 2) if there is no auth_user just check current user platform connections
// ignoreCurrentUserAuth - ignores auth_user
export default function usePlatformConnected(platform, ignoreCurrentUserAuth) {
  const user = useSelector(getCurrentUserSelector)
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const selectedPartnershipRightsHolder = useSelector(selectedPartnershipRightsHolderSelfAccountSelector)

  // if auth user exists AND user is not member of selected partnership’s rights_holder self account
  if (!!selectedPartnership.auth_user && !selectedPartnershipRightsHolder && !ignoreCurrentUserAuth) {
    // do not need to check if auth_user has authorised with the external service as if an auth_user exists it will have all auth
    // if there auth_user id exists treat all platforms as connected:
    return true
  } else {
    // when there is array of platforms return object of platforms with connection status
    if (Array.isArray(platform)) {
      return platform.reduce((acc, item) => {
        acc[item] = checkIsPlatformConnected(item, user)
        return acc
      }, {})
    } else return checkIsPlatformConnected(platform, user)
  }
}

const checkIsPlatformConnected = (platform, user) => {
  switch (platform) {
    case FACEBOOK_PLATFORM:
      return user.facebook_is_connected
    case GOOGLE_PLATFORM:
      return user.google_is_connected
    case DV_360_PLATFORM:
      return user.dv360_is_connected
    case TIKTOK_PLATFORM:
      return user.tiktok_is_connected
    default:
      return false
  }
}
